import React from 'react'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles'
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined'
import moment from 'moment'
import EditIcon from '@material-ui/icons/Edit'
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined'
import { CRM_DATE_FORMAT } from '../../constants'

const useStyles = makeStyles((theme) => ({
  notesList: {
    marginTop: 23,
  },
  noteItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 5,
  },

  noteItemLeftSide: {
    display: 'flex',
    alignItems: 'center',
    color: '#247bcd',
    maxWidth: 400,
  },
  noteItemLeftSideIcon: {
    marginRight: 4,
  },
  noteItemLeftSideText: {
    maxWidth: 300,
    wordWrap: 'break-word',
    wordBreak: 'break-all',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    cursor: 'pointer',
  },
  noteItemRightSide: {
    display: 'flex',
    alignItems: 'center',
    color: '#404040',
  },
  noteItemRightSideAuthor: {
    fontWeight: 'bold',
    maxWidth: 110,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  noteItemRightSideDateTime: {
    marginLeft: 16,
    marginRight: 13,
  },
  noteItemRightSideIcons: {
    color: '#247bcd',
    cursor: 'pointer',
  },
  noteSeeMore: {
    marginTop: 15,
    color: '#247bcd',
    textAlign: 'right',
    '& span': {
      cursor: 'pointer',
      fontSize: 16,
      fontWeight: 500,
    },
  },
}))

export default (props) => {
  let {
    state,
    openOrCloseDetailsDialog,
    openOrCloseEditDialog,
    openOrCloseDeleteDialog,
    handleSeeMore,
  } = props
  const styleClass = useStyles()

  return (
    <div className={styleClass.notesList}>
      {state.notes.map((item, index) => {
        return (
          <div className={styleClass.noteItem} key={index}>
            <div className={styleClass.noteItemLeftSide}>
              <span className={styleClass.noteItemLeftSideIcon}>
                <DescriptionOutlinedIcon />
              </span>
              <span
                className={styleClass.noteItemLeftSideText}
                onClick={() => {
                  openOrCloseDetailsDialog(item)
                }}
              >
                {item.text}
              </span>
            </div>

            <div className={styleClass.noteItemRightSide}>
              <span className={styleClass.noteItemRightSideAuthor}>
                {item.createdBy.name}
              </span>
              <span className={styleClass.noteItemRightSideDateTime}>
                {moment(item.createdAt).format(CRM_DATE_FORMAT)}
              </span>
              <span
                className={styleClass.noteItemRightSideIcons}
                onClick={() => {
                  openOrCloseEditDialog(item)
                }}
              >
                <EditIcon />
              </span>
              <span
                className={styleClass.noteItemRightSideIcons}
                onClick={() => {
                  openOrCloseDeleteDialog(item.id)
                }}
              >
                <DeleteOutlineOutlinedIcon />
              </span>
            </div>
          </div>
        )
      })}

      {state.isShowSeeMore && (
        <div className={styleClass.noteSeeMore}>
          <span onClick={handleSeeMore} className="capitalize">
            <FormattedMessage id="note.seeMore" />
          </span>
        </div>
      )}
    </div>
  )
}
